import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { FaFacebook, FaInstagram, FaGlobe } from "react-icons/fa";

const SocialStats = ({ stats }) => {
  if (!stats) return null;

  const logoSize = 25; // Size for the icons

  const cardData = [
    {
      platform: "Instagram",
      icon: <FaInstagram size={logoSize} color="#C13584" />,
      value: stats.insta ?? 0,
      bg: "#FEC5E5",
    },
    {
      platform: "Facebook",
      icon: <FaFacebook size={logoSize} color="#1877F2" />,
      value: stats.fb ?? 0,
      bg: "#D6E8FF",
    },
    {
      platform: "Website",
      icon: <FaGlobe size={logoSize} color="#555" />,
      value: stats.website ?? 0,
      bg: "#FFFDD0",
    },
  ];

  return (
    <Row className="mt-1 g-3">
      {cardData.map(({ platform, icon, value, bg }) => (
        <Col key={platform} xs={12} md={4}>
          <Card
            className="text-center shadow-sm border-0"
            style={{ backgroundColor: bg }}
          >
            <Card.Body>
              <div className="mb-1 d-flex align-items-center justify-content-between">
                <div className="d-flex">
                  {icon} 
                <div className="fw-bold ms-2 mb-1 fs-6">{platform}</div>
                </div>
                <Card.Text>{value}</Card.Text>
              </div>
              
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default SocialStats;
